import {
  patchState,
  signalStore,
  withComputed,
  withHooks,
  withMethods,
  withState,
} from '@ngrx/signals';
import { inject } from '@angular/core';
import { ActiveUserStore } from './user/active-user.state';
import { RoleStore } from './role/role.state';
import { PermissionWorkspaceMap, User, UserWorkspace } from '../models/user';
import { Access, mergeAccessList, Role } from '../models/rbac';

export type GlobalsState = {
  user: User | null;
  permissions: PermissionWorkspaceMap;
};

const initialState: GlobalsState = {
  user: null,
  permissions: {},
};

export const PermissionStore = signalStore(
  { providedIn: 'root' },
  withState(initialState),
  withComputed(({ permissions }) => ({})),
  withMethods(
    (
      store,
      activeUserStore = inject(ActiveUserStore),
      roleStore = inject(RoleStore)
    ) => ({
      setPermissions() {
        const permissions: PermissionWorkspaceMap = {};
        const user = activeUserStore.user();
        if (user) {
          user.workspaces.forEach((workspace: UserWorkspace) => {
            permissions[workspace.workspace] = mergeAccessList(
              roleStore.getByIds(workspace.roles).map((role: Role) => {
                return role.accessList;
              })
            );
          });
        }

        patchState(store, { permissions });
      },
      hasPermissions(
        workspaceIds: string[],
        actions: keyof Access | Array<keyof Access>
      ): boolean {
        const user = store.user();
        if (user && user.level > 0) return true;
        const permissions = store.permissions();
        let hasPermission = false;

        // Check permissions for each workspace ID
        workspaceIds.forEach(workspaceId => {
          const workspacePermissions: Access = permissions[workspaceId];

          if (workspacePermissions) {
            if (Array.isArray(actions)) {
              const allActionsPermitted = actions.some(
                (action: keyof Access) => {
                  return workspacePermissions[action];
                }
              );
              if (allActionsPermitted) {
                hasPermission = true;
                return;
              }
            } else {
              // If actions is a single key, check if it is present in the permissions
              if (workspacePermissions[actions as keyof Access]) {
                hasPermission = true;
                return;
              }
            }
          }
        });
        return hasPermission;
      },
      isSuperAdmin() {
        const user = activeUserStore.user();
        return user?.isAdmin;
      },
    })
  ),
  withHooks({
    onInit(store) {
      //console.log('TRY TO SET PERMISSIONS:');
      //store.setPermissions();
    },
    onDestroy() {
      console.log('on destroy');
    },
  })
);
